export const createTagLink = (tagSlug: string) => {
  return `/blog/tags/${tagSlug}`;
};
